import { useFieldArray, useFormContext } from 'react-hook-form';

import { useFormBlocks } from '~/core/shared/hooks';
import { useDefaultValuesForFormFields } from '../../../../hooks/workflowFormFields';
import { HasManyHandlerProps } from '../../types/documentDataViewHandlerProps';
import { DocumentDataViewHasManyFormValues } from '../../types/DocumentDataViewHasManyFormValues';

export const useHasManyHandler = <DocumentDefinition>(
  documentPath: HasManyHandlerProps<DocumentDefinition>['documentPath'],
  additionalValues: HasManyHandlerProps<DocumentDefinition>['additionalValues'],
) => {
  const { control } = useFormContext<DocumentDataViewHasManyFormValues>();

  const formFieldBlocks = useFormBlocks(additionalValues?.formBlocks || []);
  const additionalValuesDefaultValue = useDefaultValuesForFormFields(
    formFieldBlocks,
    documentPath,
  );

  const additionalValuesFieldArray = useFieldArray({
    control,
    name: 'additionalValues',
    keyName: '_id',
  });
  const existingValuesFieldArray = useFieldArray({
    control,
    name: 'existingValues',
    keyName: '_id',
  });

  return {
    existingValuesFieldArray,
    additionalValuesFieldArray,
    additionalValuesDefaultValue,
  };
};
